
import React from 'react';
import Hero from '@/components/Hero';
import BishopWelcome from '@/components/BishopWelcome';
import QuickLinks from '@/components/QuickLinks';
import Footer from '@/components/Footer';
import YearTheme from '@/components/YearTheme';
import UpcomingEvents from '@/components/UpcomingEvents';
import GalleryPreview from '@/components/GalleryPreview';
import SeoHead from '@/components/Seo';
import BirthdayCelebrants from '@/components/BirthdayCelebrants';


const Home = () => {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Welcome to Ibadan South Diocese"
        description="The Joy of the Lord, our strength"
        ogImage="https://res.cloudinary.com/dwrqyrm84/image/upload/v1750874183/home_ss1tdy.jpg"
        url="https://ibadansouthanglicandiocese.org.ng/"
      />
      <Hero />
      <BishopWelcome />
      <YearTheme />
      <UpcomingEvents />
      <GalleryPreview />
      <BirthdayCelebrants />
      <QuickLinks />
      {/* <LiveStreamPreview />
      <LatestSermons />
      <NewsFeed />
      <MinistriesOverview />
      <PrayerWidget /> */}
      {/* <Footer /> */}
    </div>
  );
};


export default Home;
